const dimensions = {
  spacing: (factor: number) => {
    const space = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40];
    return space[factor] || factor * 4;
  },
  breakpointXs: '980px',
  breakpointSm: '1500px',
  breakpointMd: '1648px',
  breakpointLg: '2048px',
  breakpointXl: '3840px',
  borderRadius: '5px',
};

export default dimensions;
